<template>
    <component v-if="blockComponent" :is="blockComponent" />
</template>

<script setup lang="ts">
import { useApiProxy } from "@/Hook/useProxy";
import { ContentBlock } from "@/types";
import defineContent from "@/utils/render";
import { onMounted, shallowRef } from "vue";

const { id, ssrData } = defineProps<{
    id?: number | string;
    // Server-resolved block content (html), injected by ShortcodeResolver for
    // the `[content_block id=...]` shortcode so it renders during SSR.
    ssrData?: { content?: string };
}>();

const { request } = useApiProxy<any>();

const blockComponent = shallowRef<ReturnType<typeof defineContent> | null>(
    ssrData?.content ? defineContent(ssrData.content) : null,
);

onMounted(function () {
    // Already seeded from the server — nothing to fetch.
    if (ssrData?.content) return;

    if (id)
        request(route("get.content.block", { content_block: id }), {}, true, 30000)
            .then(function (content: ContentBlock | null) {
                blockComponent.value = content ? defineContent(content.content) : null;
            })
            .catch(console.error);
});
</script>
